import { Injectable } from '@angular/core';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DiscussionsService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    getDiscussions(page: any): any {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getAllDiscussions?page=' + page + '&pageSize=5');
    }

    getRelatedDiscussionsByTags(discussionId: any, page: any): any {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getRelatedDiscussionsByTags?discussionId=' + discussionId + '&page=' + page + '&pageSize=10');
    }

    getUserDiscussions(page: any, userId: any): any {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getUserDiscussions?page=' + page + '&userId=' + userId);
    }
    addDiscussionView(discussionBoardId: any): any {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/addDiscussionView?discussionBoardId=' + discussionBoardId);
    }

    getActiveUsers(): any {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getDiscussionsActiveUser');

    }

    getAllTags(): any {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getAllTags');

    }

    //getDiscussionCategory
    getDiscussionCategory(): any {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getDiscussionCategory');

    }

    submitDiscussionBoard(myDiscussionBoard: any) {
        var response = this.http.post(this.common.apiServiceURL + 'DiscussionsV2/submitDiscussionBoard', myDiscussionBoard);
        //this.allDiscussions.push(response);
        return response;
    }

    getDiscussionById(id: any) {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getDiscussionsById?discussionId=' + id);
    }

    getDiscussionTag(discussionId: any) {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getDiscussionTag?discussionId=' + discussionId);
    };

    followDiscussionBoard(discussionBoardId: any, userId: any) {
        var follow = {
            discussionBoardId: discussionBoardId,
            userId: userId
        };
        return this.http.post(this.common.apiServiceURL + 'DiscussionsV2/followOnDiscussion', follow);
    };

    unfollowDiscussion(discussionId: any, userId: any) {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/unfollowDiscussion?discussionId=' + discussionId + '&userId=' + userId);
    };

    getDiscussionAnswer(discussionId: any) {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/getDiscussionAnswer?discussionId=' + discussionId);
    };

    isBestAnswer(AnswerId: any) {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/isBestAnswer?DiscussionAnswerId=' + AnswerId);
    }
    removeBestAnswer(AnswerId: any) {
        return this.http.get(this.common.apiServiceURL + 'DiscussionsV2/RemoveBestAnswer?DiscussionAnswerId=' + AnswerId);
    }
    answerDiscussionBoard(myAnswer: any): any {
        var response = this.http.post(this.common.apiServiceURL + 'DiscussionsV2/answerDiscussionBoard', myAnswer);
        return response;

    };
}
